import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { ArticlePostPreviewActionTypes, useArticlePostPreviewContext } from '../ArticlePostPreviewContext'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { usePostProperties } from '../usePostProperties'
import { AssigneeType, PostStatusPropertyValue } from 'api/clients/PropertyClient'
import { TopBar } from './TopBar/TopBar'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'

export const EditingTopBar = () => {
  const {
    state: { channel, isDirty, uploadingMediaFilesMetadata, initialContent },
    dispatch,
    validationErrors,
    almanacFile,
    persistChanges,
  } = useArticlePostPreviewContext()

  const saveChanges = async () => {
    await persistChanges()
    showToastMessage('Post saved!', 'success')
  }

  const { status } = usePostProperties({ id: almanacFile.id, type: AssigneeType.Article })
  const notSaveable = status?.value === PostStatusPropertyValue.AutoPostScheduled && validationErrors.length > 0

  return (
    <TopBar
      title="Edit Post"
      icon={<ChannelIcon channel={channel} />}
      leftContent={
        <Button
          variant="toggleOff"
          onPress={() => {
            if (isDirty) {
              dispatch({ type: ArticlePostPreviewActionTypes.SET_CONTENT, payload: initialContent })
            }
            dispatch({ type: ArticlePostPreviewActionTypes.SET_EDITING, payload: false })
          }}
        >
          Back
        </Button>
      }
      rightContent={
        <Button
          onPress={saveChanges}
          variant="toggleOff"
          isDisabled={!isDirty || notSaveable || uploadingMediaFilesMetadata.length > 0}
        >
          Save
        </Button>
      }
    />
  )
}
